<template>
    <div class="d-flex flex-column">
      <subnav :links="subnav" heading="Денежный поток"/>
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </template>
  
  <script>
    export default {
      metaInfo: {title: 'Новостной биллинг'},
      data: () => ({
        subnav: [
          {
            text: 'Создать новость',
            to: '/billing/news/create-news',
            exact: true,
            permission: 'web_billing_news',
          },
          {
            text: 'Все новости',
            to: '/billing/news/news-list',
            permission: 'web_billing_news',
          },
        ],
      }),
    }
  </script>
  


// WEBPACK FOOTER //
// resources/assets/js/pages/billing/news/index.vue